import { render, staticRenderFns } from "./single-training-show.vue?vue&type=template&id=669bc2f9&scoped=true"
import script from "./single-training-show.vue?vue&type=script&lang=js"
export * from "./single-training-show.vue?vue&type=script&lang=js"
import style0 from "./single-training-show.vue?vue&type=style&index=0&id=669bc2f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669bc2f9",
  null
  
)

export default component.exports